'use client';

import { useEffect } from 'react';
import { useRouter } from 'next/navigation';
import { claimWelcomeEntry } from '@/lib/welcome-entry';

export function WelcomeEntryGate() {
  const router = useRouter();

  useEffect(() => {
    try {
      if (!claimWelcomeEntry(window.sessionStorage, window.location.pathname)) return;
      const returnTo = `/${window.location.search}${window.location.hash}`;
      router.replace(`/welcome?returnTo=${encodeURIComponent(returnTo)}`, { scroll: false });
    } catch {
      // Accessing sessionStorage itself can throw. Leave the homepage available.
    }
  }, [router]);

  return null;
}
